export const ScoreRing = ({ score = 0, size = 180, stroke = 12, label = "" }) => {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = Math.max(0, Math.min(100, score)) / 100;
  const offset = circ * (1 - pct);
  const color = score >= 75 ? "#D4AF37" : score >= 50 ? "#DCDCD0" : "#A3A3A3";

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="overall-score-ring">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="#262626" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={radius} stroke={color} strokeWidth={stroke} fill="none"
          strokeLinecap="round" strokeDasharray={circ} strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 1.4s cubic-bezier(0.22,1,0.36,1)" }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-heading text-5xl font-500 text-cream" data-testid="overall-score-value">{score}</span>
        <span className="text-[10px] uppercase tracking-[0.25em] text-gold">{label}</span>
      </div>
    </div>
  );
};
